import { OnInit } from '@angular/core';
var FooterLinkComponent = /** @class */ (function () {
    function FooterLinkComponent() {
    }
    FooterLinkComponent.prototype.ngOnInit = function () {
    };
    return FooterLinkComponent;
}());
export { FooterLinkComponent };
